import { stateFromHTML } from "draft-js-import-html";

export const isEmptyHTML = (htmlString) => {
  const contentState = stateFromHTML(htmlString);
  return !contentState.hasText();
};
